import { fromJS } from 'immutable';
import {
  SIGN_RESET,
  SIGN_LOADER_MODE_UPDATE,
  SIGN_KEYPAD_MODE_UPDATE,
  SIGN_KEYPAD_CLEAR,
  SIGN_KEYPAD_KEY_ADD,
  SIGN_KEYPAD_KEY_REMOVE,
  SIGN_FETCH_REQUESTED,
  SIGN_FETCH_SUCCEEDED,
  SIGN_FETCH_FAILED
} from '../../actions';
import { requestedReducer, succeededReducer, failedReducer } from '../request';

const initialState = {
  name: '',
  countdown: '-1',
  loader: {
    mode: 0
  },
  info: {
    visible: true,
    mode: 'BACKGROUND' // BACKGROUND || NO_BACKGROUND || SMALL
  },
  video: {
    visible: false,
    url: '',
    request: {
      requested: false,
      succeeded: false,
      failed: false
    }
  },
  callToAction: {
    visible: false
  },
  keypad: {
    visible: false,
    valid: false,
    number: '',
    mode: 0
  },
  thankYou: {
    visible: false
  }
};

function validatePhoneNumber(number) {
  const phoneno = /^\d{10}$/;
  if (number.match(phoneno)) {
    return true;
  }
  return false;
}

function signLoaderModeUpdate(state, action) {
  let newState = fromJS(state);
  const { mode } = action.data;
  let loader = newState.get('loader');
  loader = loader.merge({ mode });
  newState = newState.merge({ loader });
  return newState.toJS();
}

function signKeypadModeUpdate(state, action) {
  const { mode } = action.data;
  let newState = fromJS(state);
  let keypad = newState.get('keypad');
  keypad = keypad.merge({ mode });
  newState = newState.merge({ keypad });
  return newState.toJS();
}

function signKeypadClear(state) {
  let newState = fromJS(state);
  let keypad = newState.get('keypad');
  keypad = keypad.merge({ number: '', valid: false });
  newState = newState.merge({ keypad });
  return newState.toJS();
}

function signKeypadKeyAdd(state, action) {
  let newState = fromJS(state);
  const { key } = action.data;
  let keypad = newState.get('keypad');
  let number = keypad.get('number');

  if (number.length < 10) {
    number = number.concat(key);
    keypad = keypad.merge({ number, valid: validatePhoneNumber(number) });
  }

  newState = newState.merge({ keypad });
  return newState.toJS();
}

function signKeypadKeyRemove(state) {
  let newState = fromJS(state);
  let keypad = newState.get('keypad');
  let number = keypad.get('number');
  number = keypad.get('number').slice(0, number.length - 1);
  keypad = keypad.merge({ number, valid: validatePhoneNumber(number) });
  newState = newState.merge({ keypad });
  return newState.toJS();
}

function signRequested(state) {
  let newState = fromJS(state);
  let video = newState.get('video');
  const request = fromJS(requestedReducer(video.get('request').toJS()));
  video = video.merge({ request });
  newState = newState.merge({ video });
  return newState.toJS();
}

function signSucceeded(state, action) {
  let newState = fromJS(state);

  let video = newState.get('video');
  const request = fromJS(succeededReducer(video.get('request').toJS()));

  let name = '';
  let url = '';

  if (action.data.length > 0) {
    url = `http://${action.data[0].fields.video.fields.file.url.slice(2)}`;
    name = action.data[0].fields.name; // eslint-disable-line
    video = video.merge({ url });
  }

  video = video.merge({ request });
  newState = newState.merge({ video, name });
  return newState.toJS();
}

function signFailed(state) {
  let newState = fromJS(state);
  let video = newState.get('video');
  const request = fromJS(failedReducer(video.get('request').toJS()));
  video = video.merge({ request });
  newState = newState.merge({ video });
  return newState.toJS();
}

export default function(state, action) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SIGN_RESET:
      return Object.assign({}, initialState);
    case SIGN_LOADER_MODE_UPDATE:
      return signLoaderModeUpdate(state, action);
    case SIGN_KEYPAD_MODE_UPDATE:
      return signKeypadModeUpdate(state, action);
    case SIGN_KEYPAD_CLEAR:
      return signKeypadClear(state, action);
    case SIGN_KEYPAD_KEY_ADD:
      return signKeypadKeyAdd(state, action);
    case SIGN_KEYPAD_KEY_REMOVE:
      return signKeypadKeyRemove(state, action);
    case SIGN_FETCH_REQUESTED:
      return signRequested(state, action);
    case SIGN_FETCH_SUCCEEDED:
      return signSucceeded(state, action);
    case SIGN_FETCH_FAILED:
      return signFailed(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sign/index.js